<template>
    <div class="container">
        <ClcmsMenu @productsSelect="productsSelect"/>
        <div>
            <div class="title" data-aos="fade-up">GMP标准认证培训服务</div>
            <div class="content" v-for="item in content" data-aos="fade-up">
                <div class="contentTitle">{{item.title}}</div>
                <div class="text" v-html="item.text"></div>
            </div>
        </div>
    </div>
</template>

<script>
import ClcmsMenu from "../../components/ClcmsMenu";
export default {
    name:'Gmp',
    components: {ClcmsMenu},
    data(){
      return {
          content:[
              {
                  title:'关于GMP',
                  text:'GMP是英文 GOOD MANUFACTURING PRACTICE 的缩写，中文含义是“良好生产规范”。世界卫生组织将GMP定义为指导食物、药品、医疗产品生产和质量管理的法规。<br>' +
                      'GMP是一套适用于制药、食品等行业的强制性标准，要求企业从原料、人员、设施设备、生产过程、包装运输、质量控制等方面按国家有关法规达到卫生质量要求，形成一套可操作的作业规范帮助企业改善企业卫生环境，及时发现生产过程中存在的问题，加以改善。简要的说，GMP要求制药、食品等生产企业应具备良好的生产设备，合理的生产过程，完善的质量管理和严格的检测系统，确保最终产品质量（包括食品安全卫生）符合法规要求。'
              },
              {
                  title:'GMP认证',
                  text:'中国卫生部于1995年7月11日下达卫药发（1995）第35号"关于开展药品GMP认证工作的通知"。药品GMP认证是国家依法对药品生产企业（车间）和药品品种实施GMP监督检查并取得认可的一种制度。虽然国际上药品的概念包括兽药，但只有中国和澳大利亚等少数几个国家是将人用药GMP和兽药GMP分开的。<br>' +
                      '药品GMP认证分为国家和省两级进行，根据《中华人民共和国药品管理法实施条例》的规定，省级以上人民政府药品监督管理部门应当按照《药品生产质量管理规范》和国务院药品监督管理部门规定的实施办法和实施步骤，组织对药品生产企业的认证工作；符合《药品生产质量管理规范》的，发给认证证书。其中，生产注射剂、放射性药品和国务院药品监督管理部门规定的生物制品的药品生产企业的认证工作，由国务院药品监督管理部门负责。 '
              }
          ]
      }
    },
    methods:{
        productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .title{
        width: 682px;
        height: 60px;
        font-family: SourceHanSansCN-Normal;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 24px;
        letter-spacing: 2px;
        color: #ed1c24;
        margin: 0 17.5% 65px;
        padding-top: 100px;
        background: url("../../assets/img/products/Gmp/title.png") 100% 100% no-repeat;
        text-align: center;
    }
    .content{
        margin-left: 110px;
        .contentTitle{
            background-color: #006efd;
            padding: 0 21px;
            height: 27px;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 27px;
            letter-spacing: 2px;
            color: #ffffff;
            display: inline-block;
        }
        .text{
            width: 961px;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 1px;
            color: #000000;
            padding-left: 19px;
            margin-top: 24px;
            margin-bottom: 59px;
        }
    }
</style>
